var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "top-menu" },
        [
          _c(
            "router-link",
            { attrs: { to: { name: _vm.newAudienceRoute } } },
            [
              _c("Button", { attrs: { size: "small" } }, [
                _c("i", { staticClass: "fas fa-plus" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.resource(
                        "AudienceManager_Overview_NewAudience_Button"
                      )
                    ) +
                    "\n            "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Concept", {
        attrs: { columns: _vm.columns },
        on: {
          refresh: function($event) {
            return _vm.reload()
          }
        }
      }),
      _vm._v(" "),
      _c("Published", {
        attrs: { columns: _vm.columns },
        on: {
          refresh: function($event) {
            return _vm.reload()
          }
        }
      }),
      _vm._v(" "),
      _c("Inactive", {
        attrs: { columns: _vm.columns },
        on: {
          refresh: function($event) {
            return _vm.reload()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }